import { render, staticRenderFns } from "./ExcelContactos.vue?vue&type=template&id=f788867a"
import script from "./ExcelContactos.vue?vue&type=script&lang=js"
export * from "./ExcelContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports